import { useMemo } from 'react';

import { ModuleEntityType } from '~/common/types';
import { DateRangeProvider } from '~/components/DateRangeProvider';
import { ModuleContextProvider, ModuleContextProviderValue } from '~/components/ModuleContextProvider';
import { ModulePage } from '~/components/ModulePage/ModulePage';
import { useModulePageConfig } from '~/components/ModulePageConfigProvider';
import { ModuleSlot } from '~/components/ModuleSlot/ModuleSlot';
import { ResponsibleUsersProvider } from '~/components/ResponsibleUsersProvider';
import { ModuleSlotId } from '~/modules';
import { usePurchaseRequisitionDetail, useTabId } from '~/modules/Module.hooks';
import { RouteId } from '~/routes';

import { PurchaseRequisitionDetailHeader } from './PurchaseRequisitionDetailHeader/PurchaseRequisitionDetailHeader';

export const PurchaseRequisitionDetail = () => {
  const { purchaseRequisitionId } = usePurchaseRequisitionDetail();
  const { tabId } = useTabId();

  const { modules, tabs } = useModulePageConfig({ pageId: RouteId.purchaseRequisitionDetail(), tabId });

  const contextValue = useMemo<ModuleContextProviderValue>(
    () => ({ entity: ModuleEntityType.PURCHASE_REQUISITION, entityId: purchaseRequisitionId }),
    [purchaseRequisitionId],
  );

  return (
    <DateRangeProvider>
      <ResponsibleUsersProvider>
        <ModulePage
          header={<PurchaseRequisitionDetailHeader id={purchaseRequisitionId} tabs={tabs} />}
          modules={
            <ModuleContextProvider value={contextValue}>
              <ModuleSlot id={ModuleSlotId.MAIN} modules={modules} />
            </ModuleContextProvider>
          }
        />
      </ResponsibleUsersProvider>
    </DateRangeProvider>
  );
};
